import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from './LanguageSelector';

interface ToolbarProps {
  onClearMap?: () => void;
}

export function Toolbar({ onClearMap }: ToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="h-16 border-b border-wood-warm/30 bg-white-cream/70 backdrop-blur-lg px-4 flex items-center gap-2">
      <div className="flex items-center gap-3">
        <img 
          src="/logo.png" 
          alt="Siella Logo" 
          className="h-[60px] w-auto object-contain drop-shadow-[0_2px_4px_rgba(0,0,0,0.1)]"
        />
      </div>
      <div className="ml-auto flex items-center gap-4">
        <LanguageSelector />
        {onClearMap && (
          <button
            onClick={onClearMap}
            className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-md transition-colors"
            title="Clear map and start over"
          >
            <RotateCcw className="h-4 w-4" />
            <span>{t('toolbar.clearMap')}</span>
          </button>
        )}
      </div>
    </div>
  );
}

